import {AppFormRequest} from '../app-form-request';

export class AppFormRequestEdit<T> {

    private form: AppFormRequest<T>;

    constructor(form: AppFormRequest<T>) {
        this.form = form;
        this.init();
    }

    private init() {
        this.form.onLoad(resolve => {
            const params: {p3?: string; id?: string} = {};

            if (this.form.generic) {
                params['p3'] = this.form.registerId;
            } else {
                params['id'] = this.form.registerId;
            }

            this.form.requestGET
                .response((data) => {
                    if (data[0]) {
                        for (const x in data[0]) {
                            if (data[0][x]) {
                                (this.form.model as Record<string, string>)[x] = data[0][x] as string;
                            }
                        }
                    }
                    resolve(true);
                });

            this.form.requestGET
                .cancelablePerform(params as T[]);
        });

        this.form.afterLoad(resolve => {
            this.form.requestGET.unsuscribe();
            resolve(true);
        });

        this.form.onUpdate(resolve => {
            (this.form.model as Record<string, number>)['@_update_@'] = 0;

            setTimeout(() => {
                delete (this.form.model as Record<string,number>)['@_update_@'];
            }, 10);

            resolve(true);
        });

        this.form.beforeSend(resolve => {
            if (this.form.fieldsToSend) {
                for (const x in this.form.model) {
                    if (this.form.model[x]) {
                        let founded = false;

                        this.form.fieldsToSend.forEach(field => {
                            if (field === x) {
                                founded = true;
                            }
                        });

                        if (!founded) {
                            delete this.form.model[x];
                        }
                    }
                }
            }

            resolve(true);
        });

        this.form.onSend(resolve => {
            this.form.requestPUT.safePerform(this.form.model as T[]);
            this.form.requestPUT.response(() => {
                resolve(true);
            });
        });

        this.form.onFinish(resolve => {
            setTimeout(() => {
                this.form.requestPUT.unsuscribe();
            }, 1000);
            resolve(true);
        });

    }
}
